$('#filter_mark').css({'display':'block'});
$('#filter_model').css({'display': 'block'});
$('#filter_serie').css({'display':'block'});
$('#filter_generation').css({'display':'block'});
$('#filter_modification').css({'display':'block'});


$('#filter_mark').on('change', function () {
    $('#filter_model').html('');
    $('#filter_generation').html('');
    $('#filter_serie').html('');
    $('#filter_modification').html('');

    console.log('CHANGED!!!');


    var data = 'mark=' + $(this).val()+ '&_csrf='+$('#_csrf').val();
    var mark = $(this).val();
    $.ajax({
        url: '/admin/question/models',
        type: 'post',
        data: data,
        dataType:'json',
        success:function (data) {
            $('#filter_model').html('');
            console.log(data);
            let filter_selectize = $('#filter_model')[0].selectize;
            filter_selectize.clearOptions();
            for (i=0;i<data.output.length;i++){
                filter_selectize.addOption({
                  'value': data.output[i].id,
                  'text': data.output[i].name
                });
            }
            $('#filter_model').removeAttr('disabled').prepend('<option selected value="0">Выберите модель</option>');
            filter_selectize.refreshOptions();
        },
        error:function (data) {
            console.log(data);
        }
    });
})

$('#filter_model').on('change', function () {

    var data = 'model=' + $(this).val()+ '&_csrf='+$('#_csrf').val();
    $.ajax({
        url: '/admin/question/generations',
        type: 'post',
        data: data,
        dataType:'json',
        success:function (data) {
            $('#filter_generation').html('');
            console.log(data);
            let filter_selectize = $('#filter_generation')[0].selectize;
            filter_selectize.clearOptions();
            for (i=0;i<data.output.length;i++){
                filter_selectize.addOption({
                  'value': data.output[i].id,
                  'text': data.output[i].name
                });
            }
            $('#filter_generation').removeAttr('disabled').prepend('<option selected value="0">Выберите год</option>');
            filter_selectize.refreshOptions();
        },
        error:function (data) {
            console.log(data);
        }
    });
});

$('#filter_generation').on('change', function () {
    var data = 'model=' + $('#filter_model').val() + '&generation=' + $(this).val() + '&_csrf='+$('#_csrf').val();
    $.ajax({
        url: '/admin/question/series',
        type: 'post',
        data: data,
        dataType:'json',
        success:function (data) {
            console.log(data);
            let filter_selectize = $('#filter_serie')[0].selectize;
            filter_selectize.clearOptions();
            for (i=0;i<data.output.length;i++){
                filter_selectize.addOption({
                  'value': data.output[i].id,
                  'text': data.output[i].name
                });
            }
            $('#filter_serie').removeAttr('disabled').prepend('<option selected value="0">Выберите тип кузова</option>');
            filter_selectize.refreshOptions();
        },
        error:function (data) {
            console.log(data);
        }
    });
});

$('#filter_serie').on('change', function () {
    var data = 'model=' + $('#filter_model').val() + '&serie=' + $('#filter_serie').val() + '&_csrf='+$('#_csrf').val();
    $.ajax({
        url: '/admin/question/modifications',
        type: 'post',
        data: data,
        dataType:'json',
        success:function (data) {
            console.log(data);
            let filter_selectize = $('#filter_modification')[0].selectize;
            filter_selectize.clearOptions();
            for (i=0;i<data.output.length;i++){
                filter_selectize.addOption({
                  'value': data.output[i].id,
                  'text': data.output[i].name
                });
            }
            $('#filter_modification').removeAttr('disabled').prepend('<option selected value="0">Выберите модификацию</option>');
            filter_selectize.refreshOptions();
        },
        error:function (data) {
            console.log(data);
        }
    });
});
